import React, { useState } from 'react';
import { observer } from 'src/utils/mobx-react';
import { List as MovableList } from 'react-movable';
import { useAppStateContext } from 'src/AppState/AppState';
import {
    CompetitionsList,
    CompetitionsListItem,
} from 'src/components/SportPopup/SportCompetitions/SportCompetitions.style';
import { SportCompetitionsItem } from 'src/components/SportPopup/SportCompetitions/SportCompetitionsItem';
import { CompetitionSettingsForm as CompetitionSettingsFormNew } from 'src/components/SportPopup/SportCompetitions/SettingsForm/CompetitionSettingsForm';
import { MobxMapAutoNew } from 'src_common/common/mobx-utils/MobxMapAutoNew';
import { SportCompetitionsState } from './SportCompetitionsState';

function stopPropagation(e: React.MouseEvent): void {
    e.stopPropagation();
}

interface SportCompetitionsPropsType {
    sportId: string;
    label: string; //TODO - to be removed
}

export const SportCompetitions = observer('SportCompetitions', (props: SportCompetitionsPropsType) => {
    const appState = useAppStateContext();
    const [stateAutoMap] = useState(
        () => new MobxMapAutoNew((sportId: string) => new SportCompetitionsState(appState, sportId))
    );

    const state = stateAutoMap.get(props.sportId);

    return (
        <div className='row'>
            {state.isLoading ? <div>Please wait...</div> : null}
            <div className={state.openedCompetition === null ? 'col-12' : 'col-5'}>
                <MovableList
                    values={state.competitionsList}
                    onChange={state.onChangeDisplayOrder}
                    renderList={({ children, props }): React.ReactElement => (
                        <CompetitionsList {...props}>{children}</CompetitionsList>
                    )}
                    renderItem={({ value: item, props, isDragged }): React.ReactElement => {
                        return (
                            <CompetitionsListItem
                                key={item.id}
                                {...props}
                                isDragged={isDragged}
                                // isSelected={isSelected}
                                style={{
                                    ...props.style,
                                }}
                                onClick={(): void =>
                                    state.onClickCompetition(appState.sdkStaff.models.id.getCompetitionId(item.id))
                                }
                                data-test-competition-id={item.id}
                            >
                                <SportCompetitionsItem
                                    {...props}
                                    competitionId={appState.sdkStaff.models.id.getCompetitionId(item.id)}
                                    name={item.name}
                                    isDragged={isDragged}
                                    state={state}
                                />
                            </CompetitionsListItem>
                        );
                    }}
                />
            </div>
            {state.openedCompetition === null ? null : (
                <div className='col-7 sport-competitions__details_container'>
                    <div
                        className='sport-competitions__details'
                        onClick={stopPropagation}
                    >
                        {state.sportGrades.get().type === 'loading' ? (
                            <div>Please wait...</div>
                        ) : (
                            <CompetitionSettingsFormNew
                                sportCompetitionsState={state}
                                sportId={props.sportId}
                            />
                        )}
                    </div>
                </div>
            )}
        </div>
    );
});
